(() => {
  const SITE_KEY = "6LcCcj8sAAAAADdq6qVZ87yiX7jczCDyrz1_RK3h";

  // Dawn 常见的 checkout 入口：Cart 页按钮、Cart Drawer、以及 /checkout 链接
  const CHECKOUT_SELECTOR = 'button[name="checkout"], a[href^="/checkout"]';

  function isCaptchaReady() {
    return typeof window.grecaptcha !== "undefined" && typeof window.grecaptcha.execute === "function";
  }

  async function getToken(action) {
    return new Promise((resolve, reject) => {
      if (!isCaptchaReady()) return reject(new Error("grecaptcha not ready"));

      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(SITE_KEY, { action });
          if (!token) return reject(new Error("empty token"));
          resolve(token);
        } catch (e) {
          reject(e);
        }
      });
    });
  }

  async function gateCheckout(e, el) {
    // 已经通过过就放行（避免用户来回点）
    if (sessionStorage.getItem("rc_checkout_pass") === "1") return;

    e.preventDefault();
    e.stopPropagation();

    try {
      await getToken("begin_checkout");
      // 最简单：拿到 token 就认为是“更像真人”，放行
      sessionStorage.setItem("rc_checkout_pass", "1");

      // 继续原动作：如果是 link 就跳转，如果是 button 就触发原生提交
      if (el.tagName.toLowerCase() === "a") {
        window.location.href = el.getAttribute("href") || "/checkout";
      } else {
        // 对 button[name="checkout"]，用一次点击继续流程
        el.click();
      }
    } catch (err) {
      alert("Sorry, we couldn’t verify your session. Please try again.");
    }
  }

  document.addEventListener(
    "click",
    (e) => {
      const el = e.target.closest(CHECKOUT_SELECTOR);
      if (!el) return;
      gateCheckout(e, el);
    },
    true
  );
})();
